export const environment = {
    production: false,
    //baseURL : 'http://192.168.1.16/api/'
    //baseURL : 'http://10.200.112.173/api/'
    baseURL : 'https://dev.cnergycloud.net/api/',
     signalRHubUrl: 'https://Rapid-Web-Dev:8090/notify',
  notificationApiUrl: 'https://Rapid-Web-Dev:8090/api/Notification'
};
